// extracted by mini-css-extract-plugin
export var conversationView = "BevFE";
export var firstColumnNoTwistyWithHeaders = "DMjcl";
export var firstColumnWithHeaders = "mn28d";
export var itemView = "NV2gU";
export var standardizedFirstColumn = "mXLG_";
export var standardizedFirstColumnDep = "gi0cv";
export var standardizedSecondColumn = "Gts_D";
export var standardizedSecondColumnDep = "oegl4";